<template>
    <v-app id="inspire" >
        <v-navigation-drawer
            app
            v-model="drawer"
            :mini-variant.sync="miniVariant"
            class="app-navigation-menu"
        >
            <v-list>
                <v-list-item>
                    <v-list-item-avatar  class="elevation-1 pa-1 rounded-lg px-1" tile    size="50">
                        <v-img
                            class="mx-2"
                            contain
                            height="40"
                            src="/images/circle-logo.png"
                        />
                    </v-list-item-avatar>

                    <v-list-item-content>
                        <v-list-item-title  >
                            <div class="d-flex align-center justify-space-between  ">
                                <div>{{ $page.props.auth.user.name  }}  </div>
                                <v-btn v-if="!$vuetify.breakpoint.xs" icon small>
                                    <v-icon @click="miniVariant = !miniVariant"   class="uil-angle-left"></v-icon>
                                </v-btn>
                            </div>
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            <span class="_12px"> {{ $page.props.auth.user.email  }}</span>
                        </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-list dense nav>
                <v-subheader v-show="!miniVariant">Microcom Admin</v-subheader>
                <v-list-item-group color="primary">
                    <Link
                        as="v-list-item"
                        :href="route('admin.dashboard')"
                    >
                        <v-list-item-icon>
                             <v-icon>mdi-home</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title  >
                                Dashboard
                            </v-list-item-title>
                        </v-list-item-content>
                    </Link>

                    <Link
                        as="v-list-item"
                        :href="route('admin.contacts.index')"
                    >
                        <v-list-item-icon>
                            <v-icon>mdi-inbox</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title  >
                                Inbox
                            </v-list-item-title>
                        </v-list-item-content>
                    </Link>

<!--                    <Link-->
<!--                        as="v-list-item"-->
<!--                        :href="route('admin.portfolio.index')"-->
<!--                    >-->
<!--                        <v-list-item-icon>-->
<!--                            <v-icon>mdi-briefcase</v-icon>-->
<!--                        </v-list-item-icon>-->
<!--                        <v-list-item-content>-->
<!--                            <v-list-item-title  >-->
<!--                                Portfolio-->
<!--                            </v-list-item-title>-->
<!--                        </v-list-item-content>-->
<!--                    </Link>-->

<!--                    <Link-->
<!--                        as="v-list-item"-->
<!--                        :href="route('admin.orders.index')"-->
<!--                    >-->
<!--                        <v-list-item-icon>-->
<!--                            <v-icon>mdi-cart</v-icon>-->
<!--                        </v-list-item-icon>-->
<!--                        <v-list-item-content>-->
<!--                            <v-list-item-title  >-->
<!--                                Orders-->
<!--                            </v-list-item-title>-->
<!--                        </v-list-item-content>-->
<!--                    </Link>-->

<!--                    <Link-->
<!--                        as="v-list-item"-->
<!--                        :href="route('admin.organizations.index')"-->
<!--                    >-->
<!--                        <v-list-item-icon>-->
<!--                            <v-icon>mdi-factory</v-icon>-->
<!--                        </v-list-item-icon>-->
<!--                        <v-list-item-content>-->
<!--                            <v-list-item-title  >-->
<!--                                Organizations-->
<!--                            </v-list-item-title>-->
<!--                        </v-list-item-content>-->
<!--                    </Link>-->




                    <v-list-group
                        :value="true"
                        no-action
                    >
                        <template v-slot:activator>
                            <v-list-item-icon>
                                <v-icon>mdi-cart-variant</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>Shop</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <Link
                            as="v-list-item"
                            :href="route('admin.products.index')"
                        >
                            <v-list-item-icon>
                                <v-icon>mdi-library-shelves</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title  >
                                    Products
                                </v-list-item-title>
                            </v-list-item-content>
                        </Link>

                        <Link
                            as="v-list-item"
                            :href="route('admin.categories.index')"
                        >
                            <v-list-item-icon>
                                <v-icon>mdi-tag-multiple</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title  >
                                     Categories
                                </v-list-item-title>
                            </v-list-item-content>
                        </Link>
                        <Link
                            as="v-list-item"
                            :href="route('admin.adverts.index')"
                        >
                            <v-list-item-icon>
                                <v-icon>mdi-post-outline</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title  >
                                     Adverts
                                </v-list-item-title>
                            </v-list-item-content>
                        </Link>
                    </v-list-group>

                    <Link
                        as="v-list-item"
                        :href="route('admin.services.index')"
                    >
                        <v-list-item-icon>
                            <v-icon>mdi-domain</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title  >
                                Services
                            </v-list-item-title>
                        </v-list-item-content>
                    </Link>

                    <Link
                        as="v-list-item"
                        :href="route('admin.courses.index')"
                    >
                        <v-list-item-icon>
                            <v-icon>mdi-human-male-board-poll</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title  >
                                Training
                            </v-list-item-title>
                        </v-list-item-content>
                    </Link>

                    <Link
                        as="v-list-item"
                        :href="route('admin.teams.index')"
                    >
                        <v-list-item-icon>
                            <v-icon>mdi-account-group</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title  >
                                Teams
                            </v-list-item-title>
                        </v-list-item-content>
                    </Link>

<!--                    <Link-->
<!--                        as="v-list-item"-->
<!--                        :href="route('admin.testimonial.index')"-->
<!--                    >-->
<!--                        <v-list-item-icon>-->
<!--                            <v-icon>mdi-comment-multiple</v-icon>-->
<!--                        </v-list-item-icon>-->
<!--                        <v-list-item-content>-->
<!--                            <v-list-item-title  >-->
<!--                                Testimonial-->
<!--                            </v-list-item-title>-->
<!--                        </v-list-item-content>-->
<!--                    </Link>-->

                    <Link
                        as="v-list-item"
                        :href="route('admin.why-us.index')"
                    >
                        <v-list-item-icon>
                            <v-icon>mdi-comment-question</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title  >
                                Why Us
                            </v-list-item-title>
                        </v-list-item-content>
                    </Link>

                    <Link
                        as="v-list-item"
                        :href="route('admin.slider.index')"
                    >
                        <v-list-item-icon>
                            <v-icon>mdi-camera-switch</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title  >
                                Slider
                            </v-list-item-title>
                        </v-list-item-content>
                    </Link>
                </v-list-item-group>
            </v-list>

            <v-divider/>

        </v-navigation-drawer>

        <v-app-bar
            app
            color="white"
        >

            <v-btn  @click="drawer = !drawer" class="mr-3" icon color="primary">
                <v-icon>
                    mdi-menu
                </v-icon>
            </v-btn>
            <v-spacer/>

            <v-btn
                text
                :href="route('landing')"
                class="menu-btn mx-1 success"
                small
            >
                Website
            </v-btn>
        </v-app-bar>

        <v-main>
            <v-container fluid class="py-5">
                <slot></slot>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
export default {
    data(){
        return{
            drawer: null,
            miniVariant: null,
        }
    },

    watch: {
        $page: {
            handler() {
                const message = this.$page.props.flash.message;
                if (message != null) {
                    if(!message.optionRoute){
                        Swal.fire({
                            icon: message.type,
                            title: message.title,
                            text: message.description
                        })

                    }else{

                        Swal.fire({
                            title: message.title,
                            text:message.optiontext,
                            icon: message.type,
                            showCancelButton: true,
                            confirmButtonColor: '#42a848',
                            cancelButtonColor: '#d33',
                            cancelButtonText: 'Close',
                            confirmButtonText: 'Yes, Proceed'
                        }).then((result) => {
                            if (result.isConfirmed) {

                                this.$inertia.visit(message.optionRoute)
                            }
                        })
                    }
                }
            },
        },
    },

    methods:{
    }


}
</script>

<style  >
.glass {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 16px;
    box-shadow: 8px 10px 30px rgba(0, 100, 0, 0.1);
    backdrop-filter: blur(2px);
    -webkit-backdrop-filter: blur(2px);
    border: 1px solid rgba(255, 255, 255, 0.2);
}
</style>
